'use strict';

var _infiniteTree = require('./infinite-tree');

var _infiniteTree2 = _interopRequireDefault(_infiniteTree);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _infiniteTree2['default'];